import CategoriesManagement from "./CategoriesManagement";

export default CategoriesManagement;
